import { Button, Header, Text } from '@opengov/component-library/dist';
import { IReportColumn } from '@opengov/reporting-types/src/reportColumns-immer';

import cx from 'classnames2';
import React, { Fragment } from 'react';

import { IReportLocale } from '../../../locale';

import { IDeletionBlockingReportControls } from './ColumnSettingsModal';
import styles from './ColumnSettingsModal.scss';

const TextSnippet: React.FC = (props) => {
  return (
    <div className={cx(styles.textWrapper)}>
      <Text size="small" color="light">
        {props.children}
      </Text>
    </div>
  );
};

const ListItem: React.FC = (props) => {
  return (
    <li className={cx(styles.listItem)}>
      <Text size="small" color="light">
        {props.children}
      </Text>
    </li>
  );
};

const PromptHeader: React.FC = (props) => {
  return (
    <div className={cx(styles.header)}>
      <Header variant="h3">{props.children}</Header>
    </div>
  );
};

export const ColumnSettingsModalPromptNonDeleteable: React.FC<{
  column: IReportColumn;
  deletionBlockingReportControls: IDeletionBlockingReportControls;
  reportLocaleText: IReportLocale;
  onCancel(): void;
}> = (props) => {
  const { column, deletionBlockingReportControls, onCancel, reportLocaleText } = props;
  const { dependentColumns, isShownBy, isOrganizedBy, isCategorizedBy, isFiltered } = deletionBlockingReportControls;

  const {
    cancelButtonText,
    categorizeMenu,
    filter,
    isBeingUsedInTheFollowing,
    nonDeleteableHeader,
    organizeMenu,
    showMenu,
    toDeleteThisColumnRemoveItFromTheAbove
  } = reportLocaleText.calculations.deleteCalculationModal;
  return (
    <Fragment>
      <PromptHeader>{nonDeleteableHeader}</PromptHeader>

      <TextSnippet>
        {'"'}
        {column.displayName}
        {'"'} {isBeingUsedInTheFollowing}
      </TextSnippet>

      <ul className={styles.list}>
        {isShownBy && <ListItem>{showMenu}</ListItem>}
        {isOrganizedBy && <ListItem>{organizeMenu}</ListItem>}
        {isCategorizedBy && <ListItem>{categorizeMenu}</ListItem>}
        {isFiltered && <ListItem>{filter}</ListItem>}

        {dependentColumns.map((c) => (
          <ListItem key={c.id ?? c.displayName}>
            {'"'}
            {c.displayName}
            {'"'} {reportLocaleText.calculations.deleteCalculationModal[`${c.columnType}ColumnType`]}
          </ListItem>
        ))}
      </ul>

      <TextSnippet>{toDeleteThisColumnRemoveItFromTheAbove}</TextSnippet>

      <div className={`${styles.confirmDeleteControls}`}>
        <Button onClick={onCancel} dataTest="column-settings-delete-cancel-button">
          {cancelButtonText}
        </Button>
      </div>
    </Fragment>
  );
};

export const ColumnSettingsModalPromptDeleteable: React.FC<{
  column: IReportColumn;
  reportLocaleText: IReportLocale;
  onCancel(): void;
  onDelete(column): void;
}> = (props) => {
  const { onCancel, reportLocaleText, onDelete, column } = props;
  const { cancelButtonText, deleteButtonText, deleteColumnConfirmBody, deleteColumnConfirmHeader } =
    reportLocaleText.calculations.deleteCalculationModal;

  return (
    <Fragment>
      <PromptHeader>{deleteColumnConfirmHeader}</PromptHeader>

      <TextSnippet>{deleteColumnConfirmBody}</TextSnippet>

      <div className={`${styles.confirmDeleteControls}`}>
        <Button onClick={onCancel} dataTest="column-settings-delete-cancel-button">
          {cancelButtonText}
        </Button>

        <Button
          variant="destructive"
          onClick={() => {
            onDelete(column);
          }}
          dataTest="column-settings-delete-confirm-button"
        >
          {deleteButtonText}
        </Button>
      </div>
    </Fragment>
  );
};
